/**
 * Idempotency keys for writes (CLAUDE.md §7).
 *
 * The key is minted once per *user intent*, not per HTTP attempt — that is the
 * whole point. If the network drops between request and response, the retry
 * carries the same key and the server replays the original result instead of
 * inviting the same colleague twice.
 */

export function newIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  // Older browsers: a v4-shaped value from getRandomValues. Uniqueness is what
  // matters here, not RFC-perfect version bits.
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-4${hex.slice(13, 16)}-a${hex.slice(17, 20)}-${hex.slice(20, 32)}`
}
